var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuitCaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 5,
    fill: "#23D2FF",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.06 6.77154H13.886V5.84652C13.8839 5.34286 13.4753 4.93571 12.9716 4.93524H9.02057C8.51691 4.93571 8.10835 5.34286 8.10619 5.84652V6.77154H5.93217C5.10227 6.77154 4.4336 7.45121 4.4336 8.28112V15.4714C4.43134 16.3004 5.1018 16.9744 5.93086 16.9765H16.06C16.8892 16.9751 17.5601 16.3017 17.5586 15.4726V8.28103C17.5586 7.45121 16.8899 6.77154 16.06 6.77154ZM8.70825 5.84652C8.70995 5.67522 8.84927 5.53731 9.02057 5.53731H12.9716C13.1429 5.53731 13.2823 5.67522 13.2839 5.84652V6.77154H8.70825V5.84652ZM5.93217 7.3736H16.06C16.5581 7.37671 16.9594 7.78301 16.9565 8.28112V9.45072H5.03566V8.28112C5.03284 7.78301 5.43406 7.37671 5.93217 7.3736ZM16.9565 10.0528V11.5881H5.03566V10.0528H16.9565ZM16.06 16.3745H5.93217C5.43594 16.3733 5.03463 15.9701 5.03566 15.4739V12.1901H16.9565V15.4714C16.959 15.9676 16.5587 16.3719 16.0625 16.3745H16.06Z",
    fill: "#00005A",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitCaseIcon);
export default __webpack_public_path__ + "static/media/suitCase-icon.99dd9809993b4cd94464d1d82ee8b0b4.svg";
export { ForwardRef as ReactComponent };